export const Permissoes = {
    NaoImplementado: "not-implemented",

    /* Área restrita */
    ListarUsuariosDaAR: "ListarUsuariosDaAR",
    AtualizarUsuarioDaAR: "AtualizarUsuarioDaAR",
    AtivarUsuarioDaAR: "AtivarUsuarioDaAR",
    DesativarUsuarioDaAR: "DesativarUsuarioDaAR",

    /* Cadastro de usuario */
    CriarUsuario: "CriarUsuario",
    ListarUsuarios: "ListarUsuarios",
    AtualizarUsuario: "AtualizarUsuario",
    DesativarUsuario: "DesativarUsuario",
    AtivarUsuario: "AtivarUsuario",

    /* Cadastro de perfil */
    CriarPerfil: "CriarPerfil",
    ListarPerfis: "ListarPerfis",
    AtualizarPerfil: "AtualizarPerfil",
    DesativarPerfil: "DesativarPerfil",
    AtivarPerfil: "AtivarPerfil",

    /* Vinculo de perfil e usuário */
    VincularPerfilAoUsuario: "VincularPerfilAoUsuario",
    ListarVinculosDosPerfisAosUsuarios: "ListarVinculosDosPerfisAosUsuarios",

    ListarPermissoesDoPerfil: "ListarPermissoesDoPerfil",
    ConfigurarPermissoesDoPerfil: "ConfigurarPermissoesDoPerfil",

    /* Cadastro de pessoa */

    CriarEmpresa: "CriarEmpresa",
    ListarEmpresas: "ListarEmpresas",
    AtualizarEmpresa: "AtualizarEmpresa",
    DesativarEmpresa: "DesativarEmpresa",
    AtivarEmpresa: "AtivarEmpresa",

    CriarFornecedor: "CriarFornecedor",
    ListarFornecedores: "ListarFornecedores",
    AtualizarFornecedor: "AtualizarFornecedor",
    DesativarFornecedor: "DesativarFornecedor",
    AtivarFornecedor: "AtivarFornecedor",

    CriarCliente: "CriarCliente",
    ListarClientes: "ListarClientes",
    AtualizarCliente: "AtualizarCliente",
    DesativarCliente: "DesativarCliente",
    AtivarCliente: "AtivarCliente",

    CriarEscola: "CriarEscola",
    ListarEscolas: "ListarEscolas",
    AtualizarEscola: "AtualizarEscola",
    DesativarEscola: "DesativarEscola",
    AtivarEscola: "AtivarEscola",

    /* Cadastro de centro de custo */
    CriarCentroDeCusto: "CriarCentroDeCusto",
    ListarCentrosDeCusto: "ListarCentrosDeCusto",
    AtualizarCentroDeCusto: "AtualizarCentroDeCusto",
    DesativarCentroDeCusto: "DesativarCentroDeCusto",
    AtivarCentroDeCusto: "AtivarCentroDeCusto",

    /* Cadastro de planos de contas */
    CriarPlanoDeContas: "CriarPlanoDeContas",
    ListarPlanosDeContas: "ListarPlanosDeContas",
    AtualizarPlanoDeContas: "AtualizarPlanoDeContas",
    DesativarPlanoDeContas: "DesativarPlanoDeContas",
    AtivarPlanoDeContas: "AtivarPlanoDeContas",

    /* Cadastro de obra */
    CriarObra: "CriarObra",
    ListarObras: "ListarObras",
    AtualizarObra: "AtualizarObra",
    DesativarObra: "DesativarObra",
    AtivarObra: "AtivarObra",

    /* Cadastro de estoque */
    CriarEstoque: "CriarEstoque",
    ListarEstoques: "ListarEstoques",
    AtualizarEstoque: "AtualizarEstoque",
    DesativarEstoque: "DesativarEstoque",
    AtivarEstoque: "AtivarEstoque",

    /* Cadastro de grupo (do estoque) */
    CriarGrupoDoEstoque: "CriarGrupoDoEstoque",
    ListarGruposDoEstoque: "ListarGruposDoEstoque",
    AtualizarGrupoDoEstoque: "AtualizarGrupoDoEstoque",
    DesativarGrupoDoEstoque: "DesativarGrupoDoEstoque",
    AtivarGrupoDoEstoque: "AtivarGrupoDoEstoque",

    /* Cadastro de subgrupo do estoque */
    CriarSubgrupoDoEstoque: "CriarSubgrupoDoEstoque",
    ListarSubgruposDoEstoque: "ListarSubgruposDoEstoque",
    AtualizarSubgrupoDoEstoque: "AtualizarSubgrupoDoEstoque",
    DesativarSubgrupoDoEstoque: "DesativarSubgrupoDoEstoque",
    AtivarSubgrupoDoEstoque: "AtivarSubgrupoDoEstoque",

    /* Cadastro de NCM */
    CriarNCM: "CriarNCM",
    ListarNCM: "ListarNCM",
    AtualizarNCM: "AtualizarNCM",
    DesativarNCM: "DesativarNCM",
    AtivarNCM: "AtivarNCM",

    /* Cadastro de material */
    CriarMaterial: "CriarMaterial",
    ListarMateriais: "ListarMateriais",
    AtualizarMaterial: "AtualizarMaterial",
    DesativarMaterial: "DesativarMaterial",
    AtivarMaterial: "AtivarMaterial",

    /* Cadastro de orçamento */
    CriarOrcamento: "CriarOrcamento",
    ListarOrcamentos: "ListarOrcamentos",
    AtualizarOrcamento: "AtualizarOrcamento",
    DesativarOrcamento: "DesativarOrcamento",
    AtivarOrcamento: "AtivarOrcamento",

    /* Cadastro de banco */
    CriarBanco: "CriarBanco",
    ListarBancos: "ListarBancos",
    AtualizarBanco: "AtualizarBanco",
    DesativarBanco: "DesativarBanco",
    AtivarBanco: "AtivarBanco",

    /* Cadastro de viagem */
    CriarViagem: "CriarViagem",
    ListarViagens: "ListarViagens",
    AtualizarViagem: "AtualizarViagem",
    DesativarViagem: "DesativarViagem",
    AtivarViagem: "AtivarViagem",
    ViagemEncerrarViagem: "Viagem.EncerrarViagem",
    ViagemReabrirViagem: "Viagem.ReabrirViagem",

    /* Cadastro de tipo de viagem */
    CriarTipoDeViagem: "CriarTipoDeViagem",
    ListarTiposDeViagem: "ListarTiposDeViagem",
    AtualizarTipoDeViagem: "AtualizarTipoDeViagem",
    DesativarTipoDeViagem: "DesativarTipoDeViagem",
    AtivarTipoDeViagem: "AtivarTipoDeViagem",

    /* Cadastro de destino */
    CriarDestino: "CriarDestino",
    ListarDestinos: "ListarDestinos",
    AtualizarDestino: "AtualizarDestino",
    DesativarDestino: "DesativarDestino",
    AtivarDestino: "AtivarDestino",

    /* Cadastro de inscrições da viagem */
    ListarInscricoesDaViagem: "ListarInscricoesDaViagem",
    CriarInscricaoDaViagem: "CriarInscricaoDaViagem",
    Viagem_Inscricao_AlterarStatus: "Viagem.Inscricao.AlterarStatus",
    ViagemInscricaoPagamentoAlterarProvedor: "Viagem.Inscricao.Pagamento.AlterarProvedor",

    /* Cadastro de agência */
    CriarAgencia: "CriarAgencia",
    ListarAgencias: "ListarAgencias",
    AtualizarAgencia: "AtualizarAgencia",
    DesativarAgencia: "DesativarAgencia",
    AtivarAgencia: "AtivarAgencia",

    /* Cadastro de conta */
    CriarConta: "CriarConta",
    ListarContas: "ListarContas",
    AtualizarConta: "AtualizarConta",
    DesativarConta: "DesativarConta",
    AtivarConta: "AtivarConta",
    EncerrarConta: "EncerrarConta",

    /* Cadastro de aluno */
    ListarAlunos: "ListarAlunos",
    CriarAluno: "CriarAluno",
    AtualizarAluno: "AtualizarAluno",
    AtivarAluno: "AtivarAluno",
    DesativarAluno: "DesativarAluno",

    /* Cadastro de responsável */
    ListarResponsaveis: "ListarResponsaveis",
    CriarResponsavel: "CriarResponsavel",
    AtualizarResponsavel: "AtualizarResponsavel",
    AtivarResponsavel: "AtivarResponsavel",
    DesativarResponsavel: "DesativarResponsavel",

    //#region Financeiro

    //#region Conta
    
    //#region Movimentações
    FinanceiroContaMovimentacaoInserir : "Financeiro.Conta.Movimentacao.Inserir",
    FinanceiroContaMovimentacaoAlterar : "Financeiro.Conta.Movimentacao.Alterar",
    FinanceiroContaMovimentacaoDesativar : "Financeiro.Conta.Movimentacao.Desativar",
    FinanceiroContaMovimentacaoListarTodos : "Financeiro.Conta.Movimentacao.ListarTodos",
    FinanceiroContaMovimentacaoListarPorTitulo : "Financeiro.Conta.Movimentacao.ListarPorTitulo",
    FinanceiroContaMovimentacaoListarPorIdentificador : "Financeiro.Conta.Movimentacao.ListarPorIdentificador",
    //#endregion
    
    //#endregion

    //#region Titulo
    FinanceiroTituloAcessoExclusivoListar: "Financeiro.Titulo.AcessoExclusivo.Listar",
    FinanceiroTituloAcessoExclusivoInserir: "Financeiro.Titulo.AcessoExclusivo.Inserir",

    FinanceiroTituloInserirAReceber: "Financeiro.Titulo.InserirAReceber",
    FinanceiroTituloInserirAPagar: "Financeiro.Titulo.InserirAPagar",
    FinanceiroTituloAlterar: "Financeiro.Titulo.Alterar",
    FinanceiroTituloAtivar: "Financeiro.Titulo.Ativar",
    FinanceiroTituloDesativar: "Financeiro.Titulo.Desativar",
    FinanceiroTituloLiquidar: "Financeiro.Titulo.Liquidar",
    FinanceiroTituloListar: "Financeiro.Titulo.Listar",
    FinanceiroTituloBuscarCodigo: "Financeiro.Titulo.Buscar.Codigo",
    FinanceiroTituloLinkGerar: "Financeiro.Titulo.Link.Gerar.Codigo",

    //#region Nota
    FinanceiroTituloNotaListar: "Financeiro.Titulo.Nota.Listar",
    FinanceiroTituloNotaEmitir: "Financeiro.Titulo.Nota.Emitir",
    FinanceiroTituloNotaCancelar: "Financeiro.Titulo.Nota.Cancelar",
    //#endregion

    //#endregion

    //#region Faturamento

    //#region Serviço
    FinanceiroFaturamentoServicoListar: "Financeiro.Faturamento.Servico.Listar",
    FinanceiroFaturamentoServicoInserir: "Financeiro.Faturamento.Servico.Inserir",
    FinanceiroFaturamentoServicoAlterar: "Financeiro.Faturamento.Servico.Alterar",
    FinanceiroFaturamentoServicoDesativar: "Financeiro.Faturamento.Servico.Desativar",
    FinanceiroFaturamentoServicoAtivar: "Financeiro.Faturamento.Servico.Ativar",
    FinanceiroFaturamentoServicoBuscarCodigo: "Financeiro.Faturamento.Servico.Buscar.Codigo",
    //#endregion

    //#endregion

    //#endregion

    ListarVacinas: "ListarVacinas",
    CriarVacina: "CriarVacina",
    AtualizarVacina: "AtualizarVacina",
    AtivarVacina: "AtivarVacina",
    DesativarVacina: "DesativarVacina",

    ListarAlergias: "ListarAlergias",
    CriarAlergia: "CriarAlergia",
    AtualizarAlergia: "AtualizarAlergia",
    AtivarAlergia: "AtivarAlergia",
    DesativarAlergia: "DesativarAlergia",

    ListarEnfermidades: "ListarEnfermidades",
    CriarEnfermidade: "CriarEnfermidade",
    AtualizarEnfermidade: "AtualizarEnfermidade",
    AtivarEnfermidade: "AtivarEnfermidade",
    DesativarEnfermidade: "DesativarEnfermidade",

    ListarFichasDeSaudeDoAluno: "ListarFichasDeSaudeDoAluno",
    CriarFichaDeSaudeDoAluno: "CriarFichaDeSaudeDoAluno",
    AtualizarFichaDeSaudeDoAluno: "AtualizarFichaDeSaudeDoAluno",
    AtivarFichaDeSaudeDoAluno: "AtivarFichaDeSaudeDoAluno",
    DesativarFichaDeSaudeDoAluno: "DesativarFichaDeSaudeDoAluno",

    ViagemFinanceiroCorrecaoContabilInserir : "Viagem.Financeiro.CorrecaoContabil.Inserir",
    ViagemFinanceiroCorrecaoContabilAlterar : "Viagem.Financeiro.CorrecaoContabil.Alterar",
    ViagemFinanceiroCorrecaoContabilDesativar : "Viagem.Financeiro.CorrecaoContabil.Desativar",
    ViagemFinanceiroCorrecaoContabilAtivar : "Viagem.Financeiro.CorrecaoContabil.Ativar",
    ViagemFinanceiroCorrecaoContabilListarTodos : "Viagem.Financeiro.CorrecaoContabil.ListarTodos",
    ViagemFinanceiroCorrecaoContabilListarListarDaViagem : "Viagem.Financeiro.CorrecaoContabil.ListarListarDaViagem",
    ViagemFinanceiroCorrecaoContabilListarBuscarPorIdentificador : "Viagem.Financeiro.CorrecaoContabil.ListarBuscarPorIdentificador",

    DomainViagemInscricaoInscricaoDescontoInserir : "Domain.Viagem.Inscricao.InscricaoDesconto.Inserir",
    DomainViagemInscricaoInscricaoDescontoAlterar : "Domain.Viagem.Inscricao.InscricaoDesconto.Alterar",
    DomainViagemInscricaoInscricaoDescontoDesativar : "Domain.Viagem.Inscricao.InscricaoDesconto.Desativar",
    DomainViagemInscricaoInscricaoDescontoListarTodos : "Domain.Viagem.Inscricao.InscricaoDesconto.ListarTodos",
    DomainViagemInscricaoInscricaoDescontoListarPorIdentificador : "Domain.Viagem.Inscricao.InscricaoDesconto.ListarPorIdentificador",

    DomainViagemFinanceiroContaViagemInserir : "Domain.Viagem.Financeiro.ContaViagem.Inserir",
    DomainViagemFinanceiroContaViagemEditar : "Domain.Viagem.Financeiro.ContaViagem.Editar",
    DomainViagemFinanceiroContaViagemListar : "Domain.Viagem.Financeiro.ContaViagem.Listar",
    DomainViagemFinanceiroContaViagemAbrir : "Domain.Viagem.Financeiro.ContaViagem.Abrir",
    DomainViagemFinanceiroContaViagemLancar : "Domain.Viagem.Financeiro.ContaViagem.Lancar",
    DomainViagemFinanceiroContaViagemEncerrarConta : "Domain.Viagem.Financeiro.ContaViagem.EncerrarConta",

    //#region Domain

    //#region Financeiro
    
    //#region Relatorio
    DomainFinanceiroRelatorioFluxoRateioListar : "Domain.Financeiro.Relatorio.FluxoRateio.Listar",
    DomainFinanceiroRelatorio_TitulosAcumulados_Listar : "Domain.Financeiro.Relatorio.TitulosAcumulados.Listar",
    DomainFinanceiroRelatorio_VisaoMensal_Listar : "Domain.Financeiro.Relatorio.VisaoMensal.Listar",
    DomainRelatorioMovimentacaoConsolidadaPessoaListarTodos : "Domain.Relatorio.MovimentacaoConsolidadaPessoa.ListarTodos",
    DomainRelatorioFinanceitoContaMovimentacaoSaldoPeriodoListarTodos : "Domain.Relatorio.Financeiro.Conta.MovimentacaoSaldoPeriodo.ListarTodos",
    DomainRelatorioMovimentacaoConciliacaoListarTodos : "Domain.Relatorio.MovimentacaoConciliacao.ListarTodos",
    DomainFinanceiroRelatorio_VisaoGeralDeMovimentacoes_Listar : "Domain.Financeiro.Relatorio.VisaoGeralDeMovimentacoes.Listar",

    DomainViagemRelatorioListarInscricoesRecentes : "Domain.Viagem.Relatorio.ListarInscricoesRecentes",
    DomainViagemRelatorioRelatorioAnaliticoDeViagens : "Domain.Viagem.Relatorio.RelatorioAnaliticoDeViagens",
    //#endregion

    //#endregion

    //#region
    FinanceiroContaConciliacaoAuttarListar : "Financeiro.Conta.Conciliacao.Auttar.Listar",
    FinanceiroContaConciliacaoAuttarAdicionar : "Financeiro.Conta.Conciliacao.Auttar.Adicionar",
    FinanceiroContaConciliacaoAuttarDesativar : "Financeiro.Conta.Conciliacao.Auttar.Desativar",
    FinanceiroContaConciliacaoAuttarLogListar : "Financeiro.Conta.Conciliacao.Auttar.Log.Listar",

    FinanceiroContaConciliacaoGetNetLiquidaListar : "Financeiro.Conta.Conciliacao.GetNet.Liquida.Listar",
    FinanceiroContaConciliacaoGetNetLiquidaAdicionar : "Financeiro.Conta.Conciliacao.GetNet.Liquida.Adicionar",
    FinanceiroContaConciliacaoGetNetLiquidaDesativar : "Financeiro.Conta.Conciliacao.GetNet.Liquida.Desativar",
    FinanceiroContaConciliacaoGetNetLiquidaLogListar : "Financeiro.Conta.Conciliacao.GetNet.Liquida.Log.Listar",

    FinanceiroContaConciliacaoGetNetExtratoEletronicoListar : "Financeiro.Conta.Conciliacao.GetNet.ExtratoEletronico.Listar",
    FinanceiroContaConciliacaoGetNetExtratoEletronicoAdicionar : "Financeiro.Conta.Conciliacao.GetNet.ExtratoEletronico.Adicionar",
    FinanceiroContaConciliacaoGetNetExtratoEletronicoDesativar : "Financeiro.Conta.Conciliacao.GetNet.ExtratoEletronico.Desativar",
    FinanceiroContaConciliacaoGetNetExtratoEletronicoLogListar : "Financeiro.Conta.Conciliacao.GetNet.ExtratoEletronico.Log.Listar",

    FinanceiroContaConciliacaoPagBankListar : "Financeiro.Conta.Conciliacao.PagBank.Listar",
    FinanceiroContaConciliacaoPagBankAdicionar : "Financeiro.Conta.Conciliacao.PagBank.Adicionar",
    FinanceiroContaConciliacaoPagBankDesativar : "Financeiro.Conta.Conciliacao.PagBank.Desativar",
    FinanceiroContaConciliacaoPagBankLogListar : "Financeiro.Conta.Conciliacao.PagBank.Log.Listar",
    //#endregion

    //#endregion
};

type PermissoesType = typeof Permissoes;
export type PermissoesKeyType = {
    [FieldKey in keyof PermissoesType]: string;
};
export const PermissoesKey: PermissoesKeyType = Permissoes;

export default Permissoes;